import * as url from "../url.helper";

import { get, post,all } from "../api.helper";


export const getDropDownList = data => post(url.GET_DROPDOWN, data);

export const getDropDownNames = data => post(url.GET_DROPDOWNNAMES, data);

export const getDropDownStates = data => get(url.GET_DROPDOWN_STATES);

export const getAllDropDownValues = requestList => {
  
    return all(requestList)
}





